import { render } from "./DealerList.vue?vue&type=template&id=4086e7d2&scoped=true"
import script from "./DealerList.vue?vue&type=script&lang=js"
export * from "./DealerList.vue?vue&type=script&lang=js"

import "./DealerList.vue?vue&type=style&index=0&id=4086e7d2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4086e7d2"]])

export default __exports__